import { LabeledTags, Picture } from "/App.Components";
import { TagsColors } from "/App.GeneratedEnums";
import { createSpreadableBem } from "/Helpers/createBem";
import { NewsListItemProps } from "/Models/Generated/NewsListItemProps";
import "./NewsListItem.scss";

const NewsListItem = ({
  link,
  heading,
  published,
  picture,
  areasLabel,
  areas,
  themesLabel,
  themes,
}: NewsListItemProps) => {
  const bem = createSpreadableBem("news-list-item-norad");

  return (
    <li {...bem("")}>
      <a href={link?.href} target={link?.target} {...bem("__link")}>
        <div {...bem("__container")}>
          <div {...bem("__text")}>
            {published && <p {...bem("__published")}>{published}</p>}
            {heading && (
              <h3 {...bem("__heading")}>
                <span {...bem("__heading-text")}>{heading}</span>
              </h3>
            )}
            {((themes?.length ?? 0) > 0 || (areas?.length ?? 0) > 0) && (
              <div {...bem("__categories")}>
                <LabeledTags
                  label={themesLabel}
                  categoryTags={themes}
                  color={TagsColors.Standard}
                />
                <LabeledTags
                  label={areasLabel}
                  categoryTags={areas}
                  color={TagsColors.Standard}
                />
              </div>
            )}
          </div>
          {picture && (
            <div {...bem("__image")}>
              <Picture
                {...picture}
                pictureAspectRatio="67/50"
                pictureBehaviour="Cover"
                noAlt
              />
            </div>
          )}
        </div>
      </a>
    </li>
  );
};

export default NewsListItem;
